import React, { useContext } from 'react';
import GameContext from 'contexts/GameContext';
import { useHandHistorySnapshotMode } from 'contexts/HandHistorySnapshotModeContext';
import { useSeatRotation } from 'contexts/SeatRotationContext';
import { useTableSelector } from 'hooks/useTableSelector';

import Bet from './Bet';

const Bets = () => {
  const isHandHistorySnapshot = useHandHistorySnapshotMode();
  const players = useTableSelector((table) => table.players);
  const seatId = useTableSelector((table) => table.currentPlayer.seatId);

  const { betPositions, seatPositions } = useContext(GameContext);
  const { isRotating, slotFor, seatAt, betAt } = useSeatRotation();

  const appSeats = players?.slice(1);
  const seatCount = appSeats.length;

  if (isHandHistorySnapshot) return null;

  return (
    <>
      {appSeats.map((seat: any, index: any) => {
        const seatNumber = index + 1;

        let positionIndex = seatId < 1 ? index : seatNumber - seatId;
        if (positionIndex < 0) positionIndex = seatCount + positionIndex;

        // Bets ride the same arc as their seat during the POV rotation, then
        // settle onto the discrete slot.
        const slot = isRotating ? slotFor(seatNumber) : null;
        const betPosition =
          (slot !== null ? betAt(slot) : undefined) ??
          betPositions[positionIndex % betPositions.length];
        const seatPosition =
          (slot !== null ? seatAt(slot) : undefined) ??
          seatPositions[positionIndex % seatPositions.length];

        return (
          <Bet
            seatId={seatNumber}
            key={index}
            position={betPosition}
            seatPosition={seatPosition}
            seat={seat as any}
          />
        );
      })}
    </>
  );
};

export default Bets;
